import * as types from './mutations'
import { requestSuiviFabrication } from '../../helpers/axiossuivifabrication'

export const actions = {
  async getOfs({ commit } = {}) {
        const ofs = await requestSuiviFabrication.$get(`/ordres-fabrication/`)
        commit(types.SET_OFS, ofs.items)
        return ofs.items
  },
  async getEventsOf(_, of) {
        const events = await requestSuiviFabrication.$get(`/ordres-fabrication/${of}/evenements/`)
        return events.items
  },
  async getComponentsOf(_, of) {
        const events = await requestSuiviFabrication.$get(`/ordres-fabrication/${of}/components/`)
        return events.items
  },
  async getNomenclatureProduct(_, product) {
        const events = await requestSuiviFabrication.$get(`/nomenclature/${product}`)
        return events
  },
  async getUSageComponent(_, product) {
        const events = await requestSuiviFabrication.$get(`/nomenclature/component/${product}`)
        return events
  },
}
